import {
  MercadoPagoCardErrorMessages,
  MercadoPagoPaymentMessages,
} from 'src/utils/cards/mercadoPagoErrors';

export function getMercadoPagoCardErrorMessage(errorCode: number) {
  return MercadoPagoCardErrorMessages[errorCode]
    ? MercadoPagoCardErrorMessages[errorCode] + ` (cod. ${errorCode})`
    : `Ocurrió un error desconocido (cod. ${errorCode}). Por favor, intenta nuevamente.`;
}

export function getMercadoPagoPaymentErrorMessage(errorCode: string) {
  return (
    MercadoPagoPaymentMessages[errorCode] ||
    `Ocurrió un error desconocido (cod. ${errorCode}). Por favor, intenta nuevamente.`
  );
}
